
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-policy",
      function () {
        return require("private-next-pages/career-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-policy"])
      });
    }
  